<template>
  <div class="wrap">
    <div class="userHader">
      <div class="userInforIcon">
        <van-uploader
          class="userAdd"
          :after-read="afterRead"
          upload-icon="photograph"
        />
        <!-- <input type="file" accept="image/*" @change="getFile($event)"> -->
        <div ref="imgPreview"></div>
        <img
          :src="sicon"
          alt
          v-if="sicon.length > 0"
          style="border-radius: 50%"
        />
        <img src="../../assets/images/headericon.png" alt v-else />
      </div>
    </div>
    <div class="form">
      <div class="form-line">
        <div class="let">
          <span>真实姓名</span>
        </div>
        <div class="rigt">
          <input type="text" placeholder="请输入姓名" v-model="uName" />
        </div>
      </div>

      <!--<div class="form-line">-->
      <!--<div class="let">-->
      <!--<span>昵称</span>-->
      <!--</div>-->
      <!--<div class="rigt">-->
      <!--<input type="text"-->
      <!--placeholder="请输入昵称"-->
      <!--v-model="uUsername" />-->
      <!--</div>-->
      <!--</div>-->

      <div class="form-line">
        <div class="let">
          <span>电子邮箱</span>
        </div>
        <div class="rigt">
          <input type="email" placeholder="请输入电子邮箱" v-model="uMail" />
        </div>
      </div>


      <div class="form-line padding3">
        <div class="let">
          <span>手机号</span>
        </div>
        <div class="rigt" @click="getPhone">
          <input
            type="text"
            placeholder="请输入手机号"
            :disabled="phoneDisable"
            v-model="uPhone"
          />
          <!-- <i class="rigtIcon"></i> -->
        </div>
      </div>

      <div class="form-line">
        <div class="let">
          <span>单位</span>
        </div>
        <div class="rigt">
          <input type="text" placeholder="请输入单位" v-model="uOrg" />
        </div>
      </div>
      <!--<div class="form-line">-->
      <!--<div class="let">-->
      <!--<span>职称</span>-->
      <!--</div>-->
      <!--<div class="rigt">-->
      <!--<input type="text"-->
      <!--placeholder="请输入职称"-->
      <!--v-model="uPost" />-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="form-line">-->
      <!--<div class="let">-->
      <!--<span>地址</span>-->
      <!--</div>-->
      <!--<div class="rigt">-->
      <!--<input type="text"-->
      <!--placeholder="请输入地址"-->
      <!--v-model="uUnit" />-->
      <!--</div>-->
      <!--</div>-->
    </div>
    <div @click="save" class="save">
      <span>保存</span>
    </div>

    <div @click="logout" class="logout">
      <span>退出登录</span>
    </div>


    <div class="pops" v-show="popVsible">
      <div class="box">
        <i class="close" @click="popVsible = false"></i>
        <div class="pops-title">
          <span>设置手机</span>
        </div>
        <div class="pops-line">
          <i class="popsIcon shouji"></i>
          <input type="text" placeholder="请输入手机号" v-model="phone" />
        </div>
        <div class="pops-line pops-line1">
          <i class="popsIcon yanzheng"></i>
          <input type="text" placeholder="请输入验证码" v-model="identify" />
          <span
            class="getCode"
            :class="disable == false ? 'disableSnd' : ''"
            @click="getCode"
            >{{ code }}</span
          >
        </div>
        <div class="pops-sure" @click="popSure">
          <span>确定</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import grxx from "../../assets/images/grxx.png";
import woyy from "../../assets/images/woyy.png";
import wdsc from "../../assets/images/wdsc.png";
import next from "../../assets/images/next.png";
import loginService from "../../plugin/extendFn/loginService";
import store from "../../store";
import AppSetting from '../../AppSetting';

export default {
  data() {
    return {

      list: [
        {
          img: "grxx",
          text: "我的已购",
          next: next,
          link: "MyBuy",
          icon: "meYuyue",
        },
        // {img:grxx,text:'我的证书',next:next,link:'End'},
        {
          img: woyy,
          text: "我的预约",
          next: next,
          link: "Bespoke",
          icon: "meYigou",
        },
        {
          img: wdsc,
          text: "我的收藏",
          next: next,
          link: "Collection",
          icon: "meShoucang",
        },
      ],
      uName: null,
      wxuser: null,
      sicon: "",
      popVsible: false,
      pickerVisb: false,
      inId: "",
      inName: "",
      uIndustryName: "",
      uIndustry: "",
      InList: [],
      code: "获取验证码",
      phone: "",
      disable: true,
      identify: "",

      uUsername: "",
      uName: "",
      uPhone: "",
      uMail: "",
      uOrg: "",
      uPost: "",
      uUnit: "",
    };
  },
  props: {},
  computed: {
    phoneDisable() {
      let disable = false;
      console.log("=========================");
      console.log(this.wxuser);

      if (this.wxuser && this.wxuser.uPhone) {
        disable = true;
      }
      return disable;
    },
  },
  async mounted() {
    this. wxuser=await loginService.getLoginUser();
    this.$waiting.hide();
    if (this.wxuser) {
      this.sicon = this.wxuser.uIcon || "";
      this.uUsername = this.wxuser.uUsername || "";
      this.uName = this.wxuser.uName || "";
      this.uPhone = this.wxuser.uPhone || "";
      this.uMail = this.wxuser.uMail || "";
      this.uOrg = this.wxuser.uOrg || "";
      this.uPost = this.wxuser.uPost || "";
      this.uUnit = this.wxuser.uUnit || "";
    }

    document.title = "完善信息";
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.info();
    this.getLevelList();
  },
  methods: {
    afterRead(file) {
      console.log(file);
      let formData = new FormData();
      formData.append("file", file.file);
      //console.log(file);
      this.$postHttp(
        AppSetting.baseUrl + "/common/file/headimg/" + this.wxuser.uId,
        formData
      ).then((res) => {
        if (res.data.code == 0) {
          this.sicon = res.data.urls[0].url;
        }
      });
    },
    checkIn(res) {
      this.inId = res.dictId;
      this.inName = res.dictName;
    },
    pickerSave() {
      this.uIndustryName = this.inName;
      this.uIndustry = this.inId;
      this.pickerVisb = false;
    },
    getPhone() {
      // this.popVsible = true;
      if (this.wxuser && this.wxuser.uPhone) {
        this.topTips("手机号不可修改!");
      } else {
        this.popVsible = true;
      }
    },
    popSure() {
      // this.
      this.uPhone = this.phone;
      this.popVsible = false;
    },
    getFile(event) {
      let file = event.target.files[0];
      let formData = new FormData();
      formData.append("file", file);
      //console.log(file);
      this.$postHttp(AppSetting.baseUrl + "/common/file/headimg/" + 1, formData).then(
        (res) => {
          if (res.data.code == 0) {
            console.log(res.data);
          }
        }
      );
    },
    getCode() {
      var reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;

      if (this.phone == "") {
        this.topTips("请输入手机号!");
        return;
      } else if (!reg.test(this.phone)) {
        this.topTips("手机格式不正确!");
        return;
      }
      if (this.disable == false) {
        return;
      }
      this.$postHttp(AppSetting.baseUrl + "/login/identify", {
        phone: this.phone,
        type: "LOGIN",
      }).then((res) => {
        // console.log(res);
        if (res.data.code == 2007) {
          this.topTips("验证码发送失败");
        } else if (res.data.code == 0) {
          let num = 59;
          this.code = num + "s后重发";
          this.disable = false;
          let code = setInterval(() => {
            num--;
            this.code = num + "s后重发";
            if (num < 1) {
              this.disable = true;
              // obtn.style.color = '#007EFF';
              this.code = "重新获取";
              clearInterval(code);
            }
          }, 1000);

          // this.toast('验证码发送成功');
        } else if (res.data.code == 2008) {
          this.topTips("此手机号已被绑定!");
        }
      });
    },
    logout(){
      loginService.logout()
      // 跳转到首页
      this.$router.push({
        path:"/index/live"  
      })
    },
    save() {
      var regEmail =
        /^[a-zA-Z0-9_\.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (this.uPhone == "") {
        this.topTips("请输入手机号!");
        return;
      }
      if (this.uOrg == "") {
        this.topTips("请输入单位!");
        return;
      }

      if (this.uMail == "") {
        this.topTips("请输入邮箱!");
        return;
      } else if (!regEmail.test(this.uMail)) {
        this.topTips("邮箱格式不正确!");
        return;
      }
      let param = {
        id: this.wxuser.uId,
        uIcon: this.sicon,
        username: this.uUsername,
        name: this.uName,
        phone: this.uPhone.trim(),
        identify: this.identify.trim(),
        uMail: this.uMail,
        org: this.uOrg,
        uDepartment: this.uDepartment,
        // uDepartment:this.wxuser.uDepartment,
        uIndustry: this.uIndustry,
        addr: this.uUnit,
        post: this.uPost,
      };
      this.$postHttp(AppSetting.baseUrl + "/student/update", param).then(async (res) => {
        if (res.data.code == 0) {
          this.wxuser = res.data.student;
          await loginService.setLoginUser(this.wxuser)
          this.$router.go(-1);
        } else if (res.data.code == 2003) {
          this.topTips("请输入验证码");
        } else {
          this.topTips(res.data.msg);
        }
      });
    },

    getLevelList() {
      this.$postHttp(AppSetting.baseUrl + "/dictionary/app/list", {
        dictType: "INDUSTRY",
      }).then((res) => {
        if (res.data.code == 0) {
          let data = res.data.list;
          this.InList = data;
          data.forEach((element) => {
            if (element.dictId == this.uIndustry) {
              this.uIndustryName = element.dictName;
            }
          });
        }
      });
    },
    info() {
      //根据手机号查询真实姓名
      this.$postHttp(AppSetting.baseUrl + "/user/qryByPhone", {
        uPhone: this.wxuser.uPhone,
      }).then((res) => {
        if (res.data.code == 0) {
          //this.wxuser = res.data.student;
        }
      });
    },
  },

  destroyed() {
    // alert(111)
  },
};
</script>
<style scoped lang="scss">
.wrap {
  min-height: 100vh;
  background: #f4f5f4;

  .userHader {
    // overflow: hidden;
    font-size: 0.34rem;
    color: #fff;
    background: url("../../assets/images/title.png") no-repeat;
    padding-top: 0.3rem;
    box-sizing: border-box;
    background-size: 100% 100%;
    height: 2.3rem;
  }

  .userInforIcon {
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 50%;
    margin: auto;
    position: relative;
    // overflow: hidden;
    .userAdd {
      position: absolute;
      display: inline-block;
      width: 1.2rem;
      height: 1.2rem;
      border-radius: 50%;
      // height: 100%;
      // width: 100%;
      top: 0.5rem;
      opacity: 0;
    }

    img {
      // display: inline-block;
      width: 100%;
      height: 100%;
    }
  }

  .form {
    font-size: 0.28rem;
    color: #333333;
    width: 100%;

    .form-line {
      width: 100%;
      padding: 0px 0.3rem;
      box-sizing: border-box;
      height: 1rem;
      background: #fff;
      border-bottom: 0.02rem solid #eeeeee;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .let {
        // float: left;
        text-align: left;
      }

      .rigt {
        color: #999999;

        text-align: right;
        width: 5rem;

        input {
          outline: none;
          border: none;
          background: #fff;
          text-align: right;
          width: 100%;
        }

        .rigtIcon {
          display: inline-block;
          width: 0.14rem;
          height: 0.26rem;
          position: absolute;
          right: 0.34rem;
          top: 50%;
          margin-top: -0.13rem;
          background: url("../../assets/images/jiantou-.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }

  .save {
    font-size: 0.34rem;
    color: #fff;
    background: #05a2ff;
    width: 100%;
    text-align: center;
    line-height: 1rem;
    margin-top: 0.7rem;
  }

  .logout{
    border-style: solid;
    border-color: #05a2ff;
    font-size: 0.34rem;
    color: #05a2ff;
    background: white;
    text-align: center;
    line-height: 1rem;
    margin-top: 0.7rem;
  }
  .pops {
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    font-size: 0.32rem;
    color: #666666;
    padding-top: 50%;
    box-sizing: border-box;

    .box {
      width: 70%;
      margin: auto;
      background: #fff;
      border-radius: 0.1rem;
      padding: 0.49rem 0.49rem;
      position: relative;

      .close {
        display: inline-block;
        position: absolute;
        right: 0.3rem;
        top: 0.3rem;
        width: 0.3rem;
        height: 0.3rem;
        background: url("../../assets/images/close.png") no-repeat;
        background-size: 100% 100%;
      }

      .pops-title {
        text-align: center;
        // padding: 0.47rem 0px;
      }

      .pops-line {
        border-bottom: 0.02rem solid #d9d9d9;
        padding-bottom: 0.2rem;
        padding-top: 0.1rem;
        margin-top: 0.3rem;

        input {
          width: 50%;
          outline: none;
          border: none;
          background: #fff;
        }

        .popsIcon {
          display: inline-block;
          position: relative;
          top: 0.1rem;
          width: 0.3rem;
          height: 0.46rem;
          margin-right: 0.15rem;
        }

        .shouji {
          background: url("../../assets/images/shouji.png") no-repeat;
          background-size: 100% 100%;
        }

        .yanzheng {
          background: url("../../assets/images/yanzheng.png") no-repeat;
          background-size: 100% 100%;
        }

        .getCode {
          width: 30%;
          display: inline-block;
          // padding: 0.1rem 0.1rem;
          font-size: 0.24rem;
          color: #05a2ff;
          border: 0.02rem solid #05a2ff;
          box-sizing: border-box;
          border-radius: 0.05rem;
          text-align: center;
          line-height: 0.62rem;
          float: right;
        }

        .disableSnd {
          background: #ccc;
          color: #666;
          border: none;
        }
      }

      .pops-line1 {
        border: none;
        border-bottom: 0.02rem solid #d9d9d9;
      }

      .pops-sure {
        font-size: 0.3rem;
        color: #fff;
        line-height: 0.8rem;
        width: 4.6rem;
        margin: auto;
        text-align: center;
        background: #05a2ff;
        border-radius: 0.1rem;
        margin-top: 0.3rem;
      }
    }
  }

  .picker {
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    font-size: 14px;
    color: #666666;
    box-sizing: border-box;

    .box {
      width: 100%;
      background: #fff;
      position: absolute;
      bottom: 0px;
    }

    .picker-title {
      line-height: 1rem;
      font-size: 16px;
      color: #333333;
      background: rgba(247, 247, 247, 1);
      padding: 0rem 0.29rem;
      box-sizing: border-box;
      border-bottom: 0.02rem solid #333;

      :last-child {
        color: #007eff;
        float: right;
      }
    }

    .picker-list {
      .item {
        font-size: 14px;
        color: #333333;
        padding: 0rem 0.29rem;
        line-height: 1rem;
        border-bottom: 0.02rem solid #dcdcdc;
        position: relative;
      }

      .activeCheck {
        color: #007eff;

        .checkIcon {
          display: inline-block;
          width: 0.36rem;
          height: 0.46rem;
          background: url("../../assets/images/yanzheng.png") no-repeat;
          background-size: 100% 100%;
          position: absolute;
          right: 0.3rem;
          top: 50%;
          margin-top: -0.23rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/me/userInfor.vue